import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { saveContratDePartege } from "../../../../services/RHService/ContratDePartegeService";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";

const AddContratDePartage = () => {
  const [inputList, setInputList] = useState([{ nomCharge: "", frais: "" }]);
  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };
  const handleAddClick = () => {
    setInputList([...inputList, { nomCharge: "", frais: "" }]);
  };
  const [formData, setFormData] = useState({});
  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
  };
  useEffect(() => {
    setFormData((prevState) => ({
      ...prevState,
      charges: inputList,
    }));
  }, [inputList]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Vérifier les champs obligatoires
    if (
      !formData.intitule ||
      !formData.nomBenif ||
      !formData.dateDeb ||
      !formData.dateFin ||
      !formData.modePaiment ||
      !formData.contact ||
      !formData.desc
    ) {
      toastr.error("Veuillez renseigner tous les champs.");
      return;
    }

    // Vérifier le champ RIB si le mode de paiement est "chéque" ou "virementBoncaire"
    if (
      (formData.modePaiment === "chéque" ||
        formData.modePaiment === "virementBoncaire") &&
      !formData.rib
    ) {
      toastr.error(
        "Si vous avez choisi le mode de paiement 'chéque' ou 'Virement Bancaire', veuillez renseigner le champ RIB."
      );
      return;
    }

    // Copier le formulaire de contrat pour éviter de le modifier directement
    const contractData = { ...formData };

    // Si le mode de paiement est "espèce", supprimer la valeur du champ RIB
    if (formData.modePaiment === "espéce") {
      contractData.rib = "";
    }

    // Vérifier si les charges ont été renseignées
    const invalidNomCharge = inputList.some((item) => item.nomCharge === "");
    if (invalidNomCharge) {
      toastr.error("N'oubliez pas les charges :)");
      return;
    }

    const invalidFrais = inputList.some((item) => {
      const fraisRegex = /^\d+(\.\d{1,2})?$/;
      return !fraisRegex.test(item.frais);
    });

    if (invalidFrais) {
      toastr.error(
        "Les frais sont invalides : veuillez entrer que des chiffres."
      );
      return;
    }
    contractData.idUser = getCurrentUserId();
    // Envoyer le formulaire de contrat au serveur
    try {
      await saveContratDePartege(contractData);
      toastr.success("Contrat de partage ajouté avec succès.");

      // Faire quelque chose avec les données de réponse
    } catch (error) {
      console.log(error.message);
      // Afficher un message d'erreur ou gérer l'erreur
    }
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Ajouter une mission</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <i class="fa-solid fa-house"></i>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/mission_interne">
                    Liste des Contrats de partage
                  </Link>
                </li>
                <li className="breadcrumb-item active">
                  Ajouter un Contrat de partage
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div className="col-md-12">
            <div className="card card-dark">
              <div class="card-header">
                <h4 class="card-title">Ajouter un Contrat de partage</h4>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="card-body">
                      <div className="form-group">
                        <label>Intitulé de Contrat</label>
                        <input
                          type="text"
                          name="intitule"
                          value={formData.intitule}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              intitule: e.target.value,
                            })
                          }
                          className="form-control form-control-border"
                          placeholder="Intitulé de mission "
                        />
                      </div>

                      <div className="form-group">
                        <label>Nom de bénificitaire</label>
                        <input
                          type="text"
                          name="nomBenif"
                          value={formData.nomBenif}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              nomBenif: e.target.value,
                            })
                          }
                          className="form-control form-control-border"
                          placeholder="Nom de bénificitaire"
                        />
                      </div>
                      <div className="form-group">
                        <label>Contact</label>
                        <input
                          type="text"
                          name="contact"
                          value={formData.contact}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              contact: e.target.value,
                            })
                          }
                          className="form-control form-control-border"
                          placeholder="Contact"
                        />
                      </div>
                      <div className="form-group">
                        <label>Date de départ</label>
                        <div
                          className="input-group date"
                          id="reservationdate"
                          data-target-input="nearest"
                        >
                          <input
                            type="date"
                            id="start"
                            name="dateDeb"
                            value={formData.dateDeb}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                dateDeb: e.target.value,
                              })
                            }
                            min="1900-01-01"
                            className="form-control form-control-border "
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <label for="exampleSelectBorder">
                          Mode de paiment{" "}
                        </label>

                        <select
                          className="custom-select form-control-border"
                          name="modePaiment"
                          value={formData.modePaiment}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              modePaiment: e.target.value,
                            })
                          }
                        >
                          <option value="">-- Choisissez une option --</option>
                          <option value="espéce">Espéce</option>
                          <option value="chéque">Chéque</option>
                          <option value="virementBoncaire">
                            Virement boncaire
                          </option>
                        </select>
                      </div>
                      {(formData.modePaiment === "chéque" && (
                        <div className="form-group">
                          <label for="exampleSelectBorder">RIB</label>

                          <input
                            type="text"
                            name="rib"
                            value={formData.rib}
                            onChange={(e) =>
                              setFormData({ ...formData, rib: e.target.value })
                            }
                            className="form-control form-control-border"
                            placeholder="RIB"
                          />
                        </div>
                      )) ||
                        (formData.modePaiment === "virement_boncaire" && (
                          <div>
                            <label className="form-group">
                              <label for="exampleSelectBorder">RIB </label>
                              <input
                                type="text"
                                value={formData.rib}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    rib: e.target.value,
                                  })
                                }
                                name="rib"
                                className="form-control form-control-border"
                                placeholder="RIB"
                              />
                            </label>
                          </div>
                        ))}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card-body">
                      <div className="form-group">
                        <label>Date de fin</label>
                        <div
                          className="input-group date"
                          id="reservationdate"
                          data-target-input="nearest"
                        >
                          <input
                            type="date"
                            id="start"
                            name="dateFin"
                            value={formData.dateFin}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                dateFin: e.target.value,
                              })
                            }
                            min="1900-01-01"
                            className="form-control form-control-border "
                          />
                        </div>
                      </div>

                      <div className="form-group">
                        <label>Description</label>
                        <textarea
                          type="Textarea"
                          name="desc"
                          value={formData.desc}
                          onChange={(e) =>
                            setFormData({ ...formData, desc: e.target.value })
                          }
                          rows="2"
                          cols="33"
                          className="form-control form-control-border"
                          placeholder="Description"
                        ></textarea>
                      </div>
                      <label>Charges :</label>
                      {inputList.map((x, i) => {
                        return (
                          <div className="box">
                            <input
                              name="nomCharge"
                              className="form-control form-control-border"
                              placeholder="Nom de charge"
                              onChange={(e) => handleInputChange(e, i)}
                            />
                            <input
                              name="frais"
                              className="form-control form-control-border ml10"
                              placeholder="Frais En Dt"
                              onChange={(e) => handleInputChange(e, i)}
                            />
                            <div className="btn-box">
                              {inputList.length !== 1 && (
                                <button
                                  className="mr10 mx-1 m-1"
                                  type="button"
                                  style={{
                                    "background-color": "black",
                                    color: "white",
                                    "border-radius": "50%",
                                    "border-color": "black",
                                  }}
                                  onClick={() => handleRemoveClick(i)}
                                >
                                  <i class="fa-solid fa-minus "></i>
                                </button>
                              )}
                              {inputList.length - 1 === i && (
                                <button
                                  onClick={handleAddClick}
                                  type="button"
                                  style={{
                                    "background-color": "black",
                                    color: "white",
                                    "border-radius": "50%",
                                    "border-color": "black",
                                  }}
                                >
                                  <i class="fa-solid fa-plus"></i>
                                </button>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <button
                    type="submit"
                    className="btn btn-dark col-md-3 float-right"
                    style={{ width: "auto" }}
                  >
                    Confirmer
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddContratDePartage;
